//#region node_modules/.deno/rambda@9.4.2/node_modules/rambda/src/isNil.js
function isNil(x) {
	return x === void 0 || x === null;
}

//#endregion
export { isNil };